import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import AppHelpTooltipButton from '../../../components/designe/tooltips/AppHelpTooltipButton';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import AppNavigate from '../../../components/reusable/app-navigate/AppNavigate';
import ChoosePlanDialog from '../../../components/reusable/choose-plan-dialog/ChoosePlanDialog';
import { useUserConfig } from '../../../context/UserConfigContext';
import { usePullRefreshInvalidateTags } from '../../../hooks/usePullRefreshInvalidateTags';
import { trainingsApi } from '../../../redux/api/trainingsAPI';
import { TRAININGS } from '../../../redux/constants';
import { Paths } from '../../../shared/paths';
import TrainingTooltipContent from './TrainingTooltipContent';
import { useStyles } from './Trainings.styles';
import AvailableTrainings from './available-trainings/AvailableTrainings';
import FromMeTrainings from './from-me-trainings/FromMeTrainings';
import MyTrainings from './my-trainings/MyTrainings';
import { useTrainingsPage } from './useTrainingsPage';

const Trainings = () => {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const { options } = useUserConfig();
  const {
    planDialogOpened,
    setPlanDialogOpen,
    tabsConfig,
    onStartEmptyTrainingClick,
  } = useTrainingsPage();
  const { onRefresh } = usePullRefreshInvalidateTags([
    {
      apiSlice: trainingsApi,
      tags: [
        TRAININGS.TRAININGS,
        TRAININGS.TRAININGS_LAZY,
        TRAININGS.AVAILABLE,
        TRAININGS.CREATED_FOR_OTHERS,
        TRAININGS.EXERCISES,
      ],
    },
  ]);
  const showTooltips = options.showTooltips;
  const pageHeaderTooltip = showTooltips ? (
    <Box className={classes.headerTooltip}>
      <AppHelpTooltipButton
        placement="bottom-end"
        scrollableContent
        content={<TrainingTooltipContent t={t} />}
      />
    </Box>
  ) : null;

  return (
    <PageContainer
      title={t('trainings.trainings')}
      description={t('trainings.trainingsDescription')}
      headerContent={pageHeaderTooltip}
      onRefresh={onRefresh}>
      <div
        className={classes.trainingsWrapper}
        data-onboarding="trainingPage.root">
        {tabsConfig.length > 1 && <AppTabs config={tabsConfig} />}
        <Routes>
          <Route
            path={Paths.trainings.my}
            element={
              <MyTrainings
                tabsHidden={tabsConfig.length <= 1}
                setPlanDialogOpen={setPlanDialogOpen}
                onStartEmptyTrainingClick={onStartEmptyTrainingClick}
              />
            }
          />
          <Route path={Paths.trainings.fromMe} element={<FromMeTrainings />} />
          <Route
            path={Paths.trainings.available}
            element={<AvailableTrainings />}
          />
          <Route
            path={Paths.trainings.accessSettings}
            element={<AppNavigate to={Paths.trainings.toMy} replace />}
          />
          <Route
            path="*"
            element={<AppNavigate to={Paths.trainings.toMy} replace />}
          />
        </Routes>
      </div>
      <ChoosePlanDialog
        open={planDialogOpened}
        onClose={() => setPlanDialogOpen(false)}
        variant="subscriptionLimit"
      />
    </PageContainer>
  );
};

export default Trainings;
